// Shared helpers for the 32 Cards bet tables (reference directives v-kvalmin / v-kvalmax / v-casinobook).

// 1000 → "1K", 100000 → "1L", else the number
export function kval(n) {
  const v = Number(Number(n || 0).toFixed(2));
  if (v >= 1e3 && v < 1e5) return `${parseFloat((v / 1e3).toFixed(2))}K`;
  if (v >= 1e5) return `${parseFloat((v / 1e5).toFixed(2))}L`;
  return parseFloat(v);
}

// Book amount for a market from the page's exposure map (keyed by team/selection name)
export function bookAmount(exposures = {}, name = "") {
  const key = [name, String(name).trim(), String(name).toLowerCase().trim()].find(
    (k) => k && exposures[k] !== undefined
  );
  return key != null ? parseFloat(exposures[key]) || 0 : 0;
}

// Reference toCurrency: en-IN grouping, up to 2 decimals
export const toCurrency = (v) =>
  parseFloat(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

// v-casinobook / v-casinofancybook: book-green when > 0, book-red otherwise
export const bookClass = (amt) => (amt > 0 ? "book-green" : "book-red");
